import Slider from "react-slick";

export default function SimpleSlider(props) {
  let initialSlide = props.data.initialSlide;
  let SliderList = props.data.src.map ((src, idx) =>
    {    
        return (
            <img loading="lazy" key={idx} className="pic" alt = "" src = {src.src} ></img>
        )
    })
      const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: initialSlide
      };
      return (
        <div>
          <Slider {...settings}>
              {SliderList}
          </Slider>
        </div>
      );
  }
